// Initialize Firebase
export const firebaseConfig = {
    apiKey: "AIzaSyCxmRFJroTdhKguraaZOQlfZvGyVDusZHg",
    authDomain: "fundables-4bd84.firebaseapp.com",
    databaseURL: "https://fundables-4bd84.firebaseio.com",
    projectId: "fundables-4bd84",
    storageBucket: "fundables-4bd84.appspot.com",
    messagingSenderId: "227547615205",
    appId: "1:227547615205:web:6ccb7ef8f1972d00"
  };